import React from 'react';
import {useTranslation } from "react-i18next"; 

function Footer() {
    const { t, i18n } = useTranslation();
    
    return (
        <footer id="footer">
            <div className="footer-top">
                <div className="container">
                <div className="row">
                    <div className="col-lg-5 col-md-6">
                    <div className="footer-info">
                        <h3 className="text-old">Old Tbilisi</h3>
                        <p>
                        Nieuwstraat 20, Asse - 1730<br></br>
                        <strong>{t("phone")}:</strong> 02 502 17 29<br></br>
                        <strong>Email:</strong> info@oldtbilisi.be<br></br>
                        </p>
                        <div className="social-links mt-3">
                        <i className="fas fa-phone-alt" data-bs-toggle="modal" data-bs-target="#exampleModalCenter" ></i>
                        <i className="fas fa-envelope" data-bs-toggle="modal" data-bs-target="#exampleModalCenter2"></i>
                        <i className="fas fa-map-marker-alt" data-bs-toggle="modal" data-bs-target="#exampleModalCenter3"></i> 
                        <a href="https://www.instagram.com/old_tbilisii/" target="_blank" rel="noreferrer"><i className="fab fa-instagram"></i></a>
                        <a href="https://www.facebook.com/oldtbilisi2021/" target="_blank" rel="noreferrer" ><i className="fab fa-facebook-f"></i></a>
                        <a href="https://www.google.com/search?hl=en-BE&gl=be&q=Old+Tbilisi,+Nieuwstraat+20,+1730+Asse&ludocid=3911857777478912669&lsig=AB86z5Uuhg4bYWu02xHLGLNOMZSo#lrd=0x47c3bf6ba3d7e179:0x3649b5ec367aca9d,1" target="_blank" rel="noreferrer"><i className="fab fa-google"></i></a>
                        </div>
                        
                    </div>
                    </div>
                    <div className="col-lg-3 col-md-6 footer-links">
                    <h4>{t("useful-links")}</h4>
                    <ul className="px-3">
                        <li><i className="fas fa-angle-double-right"></i> <a href="#hero">Home</a></li>
                        <li><i className="fas fa-angle-double-right"></i> <a href="#about">{t("about")}</a></li>
                        <li><i className="fas fa-angle-double-right"></i> <a href="#menu">Menu</a></li>
                        <li><i className="fas fa-angle-double-right"></i> <a href="#specials">{t("specialities")}</a></li>
                        <li><i className="fas fa-angle-double-right"></i> <a href="#testimonials">{t("reviews")}</a></li>
                        <li><i className="fas fa-angle-double-right"></i> <a href="#contact">{t("contact-us")}</a></li>
                        <li><i className="fas fa-angle-double-right"></i> <a href="#book-a-table">{t("book-a-table")}</a></li>
                        <li><i className="fas fa-angle-double-right"></i> <a target="_blank" rel="noreferrer" href="https://www.google.com/search?hl=en-BE&gl=be&q=Old+Tbilisi,+Nieuwstraat+20,+1730+Asse&ludocid=3911857777478912669&lsig=AB86z5Uuhg4bYWu02xHLGLNOMZSo#lrd=0x47c3bf6ba3d7e179:0x3649b5ec367aca9d,3">{t("give-us-feedback")}</a></li>
                    </ul>
                    </div>
                    <div className="col-lg-4 col-md-6 footer-newsletter">
                    <h4>Newsletter</h4>
                    <p>{t("news-letter-p")}</p>
                    <form action="https://formsubmit.co/info@oldtbilisi.be" method="POST">
                        <input type="hidden" name="_subject" value={t("new-subscription")}/>
                        <input type="hidden" name="_captcha" value="false"/>
                        <input type="email" name="email"/>
                        <input type="submit" value={t("subscribe")}/>
                    </form>
                    </div>

                </div>
                <div className="container">
                <p className="text-center pt-3"><a href="https://www.takeaway.com/be-en/menu/old-tbilisi-georgisch-restaurant" rel="noreferrer" target="_blank">{t("about-us-p-3")}</a></p>
                <div className="copyright">
                &copy; Copyright <a href="#hero" className="text-old">Old Tbilisi </a> {t("all-r-r")} 2021-2022.
                </div>              
            </div>
                </div>
            </div>

        </footer>
    )
}

export default Footer;
